import React from "react";

function AlertBox({ message, onClose }) {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-[10000]"
    >
      <div className="bg-white rounded-2xl shadow-lg p-6 w-[90%] max-w-sm text-center">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">Alert</h2>
        <p className="text-gray-700 mb-6">{message}</p>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
        >
          OK
        </button>
      </div>
    </div>
  );
}

export default AlertBox;
